import React from 'react';
import styled from 'styled-components';

export const Content = (props) => {
  return (
    <>
      <ContentWrap>
        <h3>{props.title ? props.title : 'Contents'}</h3>
        <br />
        <div className='children'>{props.children}</div>
      </ContentWrap>
    </>
  );
};

const ContentWrap = styled.div`
  width: 100%;
  margin: 20px;
  height: 80vh;
  border: 2px solid ${({ theme }) => theme.a};
  border-radius: 9px;
  padding: 20px;
  margin: 20px;
  z-index: 1;
  overflow-x: hidden;

  h3 {
    font-size: 1.5rem;
    font-weight: bold;
    color: ${({ theme }) => theme.a};
    text-align: left;
    position: sticky;
    padding: 19px 0;
    top: -20px;
    bottom: 0;
    height: auto;
    z-index: 1;
    width: 100vw;
    background: ${({ theme }) => theme.navbar};
  }

  .children {
    width: 100%;
    height: 100%;
    padding: 20px;
    height: 100%;
  }
`;
